<template>
  <div v-if="isLogin && !hasMaintenance" class="relative">
    <button
      ref="buttonRef"
      class="flex items-center gap-3 rounded-full p-2 tablet:py-1 tablet:pr-3.5 desktop:pr-4"
      :class="isShowProfile ? 'bg-gray-600_a35' : 'hover:bg-gray-600_a25'"
      :title="profile.email || userName"
      @click="handleClick"
    >
      <span
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs leading-5 tablet:text-sm tablet:leading-6"
        :class="memberBadgeClass"
      >
        {{ userNameAbbrev }}
      </span>
      <span v-if="!isMobile" class="flex flex-1 flex-col">
        <span class="w-full text-left text-sm font-bold leading-6">
          {{ profile.email }}
        </span>
        <span
          v-if="profile.accountName"
          class="w-full text-left text-xs leading-5 text-gray-600"
        >
          {{ profile.accountName }}
        </span>
      </span>
    </button>

    <div
      v-if="isShowProfile"
      ref="profileRef"
      class="absolute -right-6 top-full z-10 mt-1.5 tablet:right-0"
    >
      <LayoutHeaderAccountProfile @close="isShowProfile = false" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onClickOutside } from '@vueuse/core';

  const { isMobile } = useScreen();
  const profileStore = useProfileStore();
  const { isLogin, profile, userName, userNameAbbrev, userMemberType } =
    storeToRefs(profileStore);

  const { provideMemberBadgeClass } = provideMemberStyle();

  const buttonRef = ref<HTMLElement | null>(null);
  const profileRef = ref<HTMLElement | null>(null);
  const isShowProfile = ref<boolean>(false);

  const memberBadgeClass = computed((): string => {
    return provideMemberBadgeClass(userMemberType.value);
  });

  const hasMaintenance = computed((): boolean => {
    /**
     * * NOTE: 目前是否有開啟維護公告
     * * 如果有開啟維護公告，則不顯示登入按鈕（未登入）與會員按鈕（已登入）
     */
    return !!profile.value.maintenanceTimePeriod;
  });

  const handleClick = (): void => {
    isShowProfile.value = !isShowProfile.value;
  };

  onClickOutside(
    profileRef,
    () => {
      isShowProfile.value = false;
    },
    {
      ignore: [buttonRef],
    }
  );
</script>
